import { render } from "./AdminSupport.vue?vue&type=template&id=31bad579"
import script from "./AdminSupport.vue?vue&type=script&lang=js"
export * from "./AdminSupport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__